import React from 'react';
import { Container } from './ui/Container';
export function WhyItMatters() {
  return <section className="py-24 bg-[#3D5A4C] text-white" data-id="element-155">
      <Container className="text-center max-w-4xl" data-id="element-156">
        <h2 className="text-4xl md:text-5xl font-serif mb-8" data-id="element-157">Why It Matters</h2>
        <p className="text-xl md:text-2xl font-light leading-relaxed opacity-90 mb-12" data-id="element-158">
          "Fatherhood is not about being perfect; it's about being present. It's the consistent effort, the small acts of love, and the resilience to keep showing up that truly shape our
children's lives." - Dr. Charles C. Daniels Jr.
        </p>
        <div className="grid md:grid-cols-3 gap-8 text-left mt-16" data-id="element-159">
          <div className="bg-[#2C4238] p-8 rounded-sm" data-id="element-160">
            <h3 className="text-xl font-serif mb-4 text-[#E5E5E0]" data-id="element-161">
              Emotional Stability
            </h3>
            <p className="text-[#D1D1D1] leading-relaxed" data-id="element-162">
              Consistent paternal presence provides a secure base from which
              children can explore the world with confidence and resilience.
            </p>
          </div>
          <div className="bg-[#2C4238] p-8 rounded-sm" data-id="element-163">
            <h3 className="text-xl font-serif mb-4 text-[#E5E5E0]" data-id="element-164">
              Academic Success
            </h3>
            <p className="text-[#D1D1D1] leading-relaxed" data-id="element-165">
              Engaged fathers correlate strongly with better school performance,
              higher engagement, and positive attitudes toward learning.
            </p>
          </div>
          <div className="bg-[#2C4238] p-8 rounded-sm" data-id="element-166">
            <h3 className="text-xl font-serif mb-4 text-[#E5E5E0]" data-id="element-167">
              Social Development
            </h3>
            <p className="text-[#D1D1D1] leading-relaxed" data-id="element-168">
              Fathers who model empathy and emotional regulation help their
              children develop stronger social skills and healthier
              relationships.
            </p>
          </div>
        </div>
      </Container>
    </section>;
}